import { histogramPlot, periodInput } from "../definitionHelpers";
import { COLOR_RULE } from "../indicatorTypes";
import { fillAwesomeOscillator } from "../math/awesomeOscillator";
import { smaAt } from "../math/movingAverages";
import { valuesReader } from "../math/priceSources";

/**
 * Accelerator Oscillator (research §1.4), as TV Accelerator Oscillator
 * (there the periods are fixed at 5 / 34 / 5, here they are the PO inputs):
 * the Awesome Oscillator minus its SMA over AC SMA. A column is up when
 * higher than the previous one, as in TV.
 */
export default {
  id: "accelerator-oscillator",
  name: "Accelerator Oscillator",
  isOscillator: true,
  inputs: [
    periodInput("aoShort", "AO Short", 5),
    periodInput("aoLong", "AO Long", 34),
    periodInput("acSma", "AC SMA", 5),
  ],
  plots: [
    histogramPlot("value", "Main Line", COLOR_RULE.TREND),
  ],
  buffers: ["awesome"],
  levels: [],

  calculate: (bars, { aoShort, aoLong, acSma }, series, fromIndex) => {
    const readAwesome = valuesReader(series.awesome);

    fillAwesomeOscillator({
      bars,
      shortPeriod: aoShort,
      longPeriod: aoLong,
      target: series.awesome,
      fromIndex,
    });

    for (let index = fromIndex; index < bars.length; index += 1) {
      series.value[index] = series.awesome[index] - smaAt(readAwesome, index, acSma);
    }
  },
};
